export const navlinks = [
  { route: "/adminAccount/feedbacks", label: "Feedbacks" },
  { route: "/adminAccount/trips", label: "Trips" },
  { route: "/adminAccount/referrals", label: "Referral Settings" },
];
